var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dlg",
      class: { show: _vm.showing },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.hide($event)
        }
      }
    },
    [
      _c("div", { staticClass: "box layout-column" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "popup-header" }, [
            _vm._v(_vm._s(_vm.headerLabel))
          ]),
          _vm._v(" "),
          _vm.headerClose
            ? _c(
                "div",
                { staticClass: "header-close", on: { click: _vm.hide } },
                [_vm._v("\n                x\n            ")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body flex" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _vm.applyLabel
          ? _c("div", { staticClass: "footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.hide }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.applyLabel) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }